import React from "react"
import { FaFacebookF } from "react-icons/fa"
import { FiGithub } from "react-icons/fi"
import { IconContext } from "react-icons"
import { FiTwitter } from "react-icons/fi"
import { FiLinkedin } from "react-icons/fi"
import { Link } from "gatsby"

export default function Links(props) {
  return (
    <IconContext.Provider
      value={{
        style: {
          fontSize: "30px",
          color: "white",
          padding: "10px",
          margin: "10px",
        },
      }}
    >
      <div>
        <Link to="https://www.facebook.com/hamza.aldolay" target="_blank">
          <FaFacebookF />
          {props.face}
        </Link>
        <Link to="https://github.com/Haldolaay" target="_blank">
          <FiGithub />
          {props.gethub}
        </Link>
        <Link to="https://twitter.com/Haldolaay1" target="_blank">
          <FiTwitter />
          {props.twitter}
        </Link>
        <Link to="https://www.linkedin.com/in/haldolaay" target="_blank">
          <FiLinkedin />
          {props.Linkedin}
        </Link>
      </div>
    </IconContext.Provider>
  )
}
